import { useAppI18N, variantProvider } from '@/app'
import { Profile } from '@/types'
import { shareReferralCode } from '@/utils'
import { modal } from '@codeleap/modals'
import { View, Text, Button } from '@/components'

export type ShareReferralCodeModalProps = {
  referralCode: Profile['referral_code']
}

export const ShareReferralCodeModal = modal<ShareReferralCodeModalProps>().content((props) => {
  const { toggle, referralCode } = props

  const { t } = useAppI18N()

 const onShare = () => {
  shareReferralCode(referralCode)
 }

  return (
    <View variants={['column', 'gap:2']}>
      <Text variants={['h2', 'textCenter']} text={t('share.referralCode.title')} />
      <Text variants={['p1', 'textCenter']} text={t('share.referralCode.description')} />

      <View variants={['bg:neutral2', 'paddingVertical:0.5', 'paddingHorizontal:1.5', 'border-radius:tiny', 'marginHorizontal:auto']}>
        <Text text={referralCode} variants={['h1', 'regular']} style={styles.code}/>
      </View>

      <View variants={['column', 'gap:1']}>
        <Button
          onPress={onShare}
          text={t('share.referralCode.actionButton')}
          debugName={'Share referral code'}
          variants={['fullWidth']}
        />
        <Button
          onPress={toggle}
          text={t('dismiss')}
          debugName={'Dismiss referral code share'}
          variants={['fullWidth', 'primary:minimal']}
          style={styles.dismissBtn}

        />
      </View>

    </View>
  )
}).props({ 
  showClose: false, 
  variants: ['box:responsiveness', 'centered'], 
})

const styles = variantProvider.createComponentStyle((theme) => ({
  code: {
    letterSpacing: '0.2em'
  },
  dismissBtn: {
    border: 'none'
  }
}), true)
